import {
  GetDocumentTemplateExtendsOptions,
  IDocumentTemplate,
  TListDocumentTemplateParams,
} from '@commenda/types/src/document-generation';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

interface UseDocumentTemplatesResponse {
  data: IDocumentTemplate[];
  count: number;
}

export const useDocumentTemplates = (
  queryParams?: TListDocumentTemplateParams
) => {
  const query = new URLSearchParams();
  if (queryParams?.search) query.append('search', queryParams.search);
  if (queryParams?.extends) {
    queryParams.extends.forEach((ext: GetDocumentTemplateExtendsOptions) =>
      query.append('extends', ext)
    );
  }

  const queryString = query.toString();
  const url = `${BASE_URL}/list${queryString ? `?${queryString}` : ''}`;

  const { data, error, isLoading, mutate } =
    useSWR<UseDocumentTemplatesResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
